import { render, staticRenderFns } from "./CompanyAssociatePartner.vue?vue&type=template&id=0889b93a"
import script from "./CompanyAssociatePartner.vue?vue&type=script&lang=js"
export * from "./CompanyAssociatePartner.vue?vue&type=script&lang=js"
import style0 from "./CompanyAssociatePartner.vue?vue&type=style&index=0&id=0889b93a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports